import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const Team = () => {
  const headingVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1, // Delay for each letter
        type: "spring",
        stiffness: 120,
      },
    }),
  };
  const headingText = "Advisory Body";

  const title = "Our Team";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.1, // Delay each letter animation
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };
  return (
    <div>
      <Helmet>
        {/* Basic Meta Tags */}
        <title> Our Team | Meet the Experts Behind MSB Association</title>
        <meta
          name="description"
          content="Get to know the dedicated professionals driving the MSB Association’s mission. Meet our team committed to supporting and empowering Money Service Businesses in the UK."
        />

        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="Our Team | Meet the Experts Behind MSB Association"
        />
        <meta
          property="og:description"
          content="Get to know the dedicated professionals driving the MSB Association’s mission. Meet our team committed to supporting and empowering Money Service Businesses in the UK."
        />

        <meta property="og:type" content="website" />

        {/* Twitter Meta Tags */}
      </Helmet>

      <style>
        {`
          .meta_label{
          font-size: 12px !important; 
          }

          .h3{
          font-size: 16px !important; 
          }
          `}
      </style>
      <main className="page_content">
        {/* Page Header - Start
================================================== */}
        <section
          id="overview"
          className="page_header text-center  section_decoration overflow-hidden"
          style={{ background: "#333" }}
        >
          <div className="container">
            <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{ display: "flex", justifyContent: "center" }}
            >
              {title.split("").map((letter, index) => (
                <motion.span
                  key={index}
                  custom={index}
                  variants={letterVariants}
                  style={{
                    display: "inline-block",
                    marginRight: letter === " " ? "0.3rem" : "0",
                  }}
                >
                  {letter}
                </motion.span>
              ))}
            </motion.h1>
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li className="active">
                <a href="#!">Our Team</a>
              </li>
            </ul>
          </div>
        </section>
        {/* Page Header - End
================================================== */}
        {/* Contact Section - Start
================================================== */}

        <section className="blog_section mb-2 section_space">
          <div className="container">
            {/* <h2 className="item_details_heading">
              {headingText.split("").map((char, i) => (
              <motion.span
                key={`${char}-${i}`}
                custom={i}
                initial="hidden"
                animate="visible"
                variants={headingVariants}
              >
                {char}
              </motion.span>
            ))}
              </h2> */}
            <div className="row justify-content-center align-items-center">
              <div className="col-lg-4">
                <div
                  className="blog_post_block"
                  style={{
                    padding: "20px",
                    border: "2px solid gold",
                    borderRadius: "20px",
                  }}
                >
                  <div className="post_image">
                    <a
                      href="https://uk.linkedin.com/in/vishal-patil-78181914"
                      target="_blank"
                    >
                      <img
                        src="assets/images/our-team/MSB-Vishal-Sir-Photo.png"
                        alt="Blog Post Image 1"
                      />
                    </a>
                  </div>
                  <div className="post_content pb-0 mb-0">
                    <h3 className="h3 text-dark">Mr. Vishal Ashok Patil</h3>
                    <ul className="post_meta unordered_list text-uppercase">
                      <li>
                        <a href="#!" className="text-dark">
                          {/* <span className="meta_icon">
                
                  </span> */}

                          <span className="meta_label mt-2">
                            <i className="fa-solid fa-briefcase"></i> &nbsp;
                            Chairman
                          </span>
                        </a>
                      </li>
                      {/* <li>
                <a href="#!">
                  <span className="meta_icon">
                    <img src="assets/images/icons/icon_calendar.svg" alt="Icon Calendar" />
                  </span>
                  <span className="meta_label">March 24, 2024</span>
                </a>
              </li> */}
                    </ul>
                    {/* <p className="">
              <a href="#!" className="text-dark">
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Voluptas, soluta?
              </a>
            </p> */}

                    <div
                      style={{
                        width: "100%",
                        height: "1px",
                        background: "gold",
                      }}
                    ></div>
                    <div
                      style={{ display: "flex", justifyContent: "center" }}
                      className="mt-2"
                    >
                      <a
                        className="btn-link text-dark text-center"
                        target="_blank"
                        href="https://uk.linkedin.com/in/vishal-patil-78181914"
                      >
                        <span className="btn_icon">
                          <i
                            style={{ fontSize: "30px" }}
                            className="fa-brands fa-linkedin"
                          />
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <br />
          </div>
          <div className="container-fluid " style={{ background: "#efefef" }}>
            <h2 className="item_details_heading text-center mt-5 pt-5  pb-5 ">
              {headingText.split("").map((char, i) => (
                <motion.span
                  key={`${char}-${i}`}
                  custom={i}
                  initial="hidden"
                  animate="visible"
                  variants={headingVariants}
                >
                  {char}
                </motion.span>
              ))}
            </h2>
            <div className="row justify-content-center pb-5">
              <div className="col-lg-4">
                <div
                  className="blog_post_block"
                  style={{
                    padding: "20px",
                    border: "2px solid gold",
                    borderRadius: "20px",
                  }}
                >
                  <div className="post_image">
                    <a
                      href="https://www.linkedin.com/in/kevin-mcgowan-805a9811/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app/"
                      target="_blank"
                    >
                      <img
                        src="assets/images/our-team/Kevin-Photos.png"
                        alt="Blog Post Image 1"
                      />
                    </a>
                  </div>
                  <div className="post_content">
                    <h3 className="h3 text-dark">Mr. Kevin McGowan</h3>
                    <ul className=" unordered_list text-uppercase">
                      <li>
                        <a href="#!" className="text-dark">
                          <span className="meta_icon"></span>
                          <span
                            className="meta_label fw-bolder"
                            style={{ lineHeight: "1.8" }}
                          >
                            <i className="fa-solid fa-briefcase"></i> &nbsp;
                            Currency & Foreign Exchange Expert
                          </span>
                        </a>
                      </li>
                      <li className="mt-0 pt-0">
                        {" "}
                        <a href="#!" className="text-dark">
                          <span className="meta_icon"></span>
                          <span
                            className="meta_label"
                            style={{ lineHeight: "1.8" }}
                          >
                            <i className="fa-solid fa-building"></i> &nbsp;
                            Consultant Complete Currency Ltd
                          </span>
                        </a>
                      </li>
                      <div
                        style={{
                          width: "100%",
                          height: "1px",
                          background: "gold",
                        }}
                      ></div>

                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                        className="w-100 mt-2"
                      >
                        <a
                          className="btn-link text-dark text-center"
                          target="_blank"
                          href="https://www.linkedin.com/in/kevin-mcgowan-805a9811/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app/"
                        >
                          <span className="btn_icon text-center">
                            <i
                              style={{ fontSize: "30px" }}
                              className="fa-brands fa-linkedin"
                            />
                          </span>
                        </a>
                      </div>

                      {/* <li>
                <a href="#!">
                  <span className="meta_icon">
                    <img src="assets/images/icons/icon_calendar.svg" alt="Icon Calendar" />
                  </span>
                  <span className="meta_label">March 24, 2024</span>
                </a>
              </li> */}
                    </ul>
                    {/* <p className="">
              <a href="#!" className="text-dark">
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Voluptas, soluta?
              </a>
            </p> */}
                    {/* <a className="btn-link" href="blog_details.html">
              <span className="btn_label">Read More</span>
              <span className="btn_icon"><i className="fa-regular fa-arrow-up-right" /></span>
            </a> */}
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div
                  className="blog_post_block"
                  style={{
                    padding: "20px",
                    border: "2px solid gold",
                    borderRadius: "20px",
                  }}
                >
                  <div className="post_image">
                    <a
                      target="_blank"
                      href="https://www.linkedin.com/in/wasif-mahmood-5158b74b/"
                    >
                      <img
                        src="assets/images/our-team/Wasif-Photos.png"
                        alt="Blog Post Image 1"
                      />
                    </a>
                  </div>
                  <div className="post_content">
                    <h3 className="h3 text-dark">Mr. Wasif Mahmood </h3>
                    <ul className="flex-column align-items-start justify-content-start unordered_list text-uppercase">
                      <li>
                        <a href="#!" className="text-dark">
                          <span className="meta_label mt-2 fw-bolder ">
                            {" "}
                            <i className="fa-solid fa-briefcase"></i> &nbsp;
                            Solicitor - Financial Crime
                          </span>
                        </a>
                      </li>
                      <li className="mt-0 pt-0">
                        {" "}
                        <a href="#!" className="text-dark">
                          <span className="meta_icon"></span>
                          <span
                            className="meta_label"
                            style={{ lineHeight: "1.8" }}
                          >
                            <i className="fa-solid fa-building"></i> &nbsp; 5
                            Pillars
                          </span>
                        </a>
                      </li>
                      {/* <li>
                <a href="#!">
                  <span className="meta_icon">
                    <img src="assets/images/icons/icon_calendar.svg" alt="Icon Calendar" />
                  </span>
                  <span className="meta_label">March 24, 2024</span>
                </a>
              </li> */}
                    </ul>
                    {/* <p className="">
              <a href="#!" className="text-dark">
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Voluptas, soluta?
              </a>
            </p> */}
                    {/* <a className="btn-link" href="blog_details.html">
              <span className="btn_label">Read More</span>
              <span className="btn_icon"><i className="fa-regular fa-arrow-up-right" /></span>
            </a> */}

                    <div
                      style={{
                        width: "100%",
                        height: "1px",
                        background: "gold",
                      }}
                    ></div>

                    <div
                      style={{ display: "flex", justifyContent: "center" }}
                      className="mt-2"
                    >
                      <a
                        className="btn-link text-dark text-center"
                        target="_blank"
                        href="https://www.linkedin.com/in/wasif-mahmood-5158b74b/"
                      >
                        <span className="btn_icon">
                          <i
                            style={{ fontSize: "30px" }}
                            className="fa-brands fa-linkedin"
                          />
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Team;
